import {deleteTask as deleteTaskGQL} from "../gql/mutations";
import {Task} from "../gql/serverTypes";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";

export const deleteTask = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    task: Task
): Promise<Task> => {
    const deletedValue = await queryGqlApi(
        deleteTaskGQL,
        {
            input: {id: task.id},
        },
        dataClientService,
        authService,
        'pgServer'
    );
    return deletedValue as unknown as Task;
};
